import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from '../constants';

export default function*() {
    yield takeLatest(ACTION.UPDATE_WAREHOUSE_STAFF.REQUEST, saga.editWarehouseStaff);
    yield takeLatest(ACTION.UPDATE_WAREHOUSE_STAFF.SUCCESS, saga.editWarehouseStaffSuccess);
}